import { render } from "./AppFrame.vue?vue&type=template&id=bdb98f36&scoped=true"
import script from "./AppFrame.vue?vue&type=script&lang=js"
export * from "./AppFrame.vue?vue&type=script&lang=js"

import "./AppFrame.vue?vue&type=style&index=0&id=bdb98f36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb98f36"]])

export default __exports__